import type { Styles } from '@adornis/ass/style';
import { css } from '@adornis/chemistry/directives/css';
import { XRedirect } from '@adornis/redirect/client/x-redirect';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import './../d-icon';

@customElement('d-redirect')
export class DubniumRedirec extends XRedirect {
  protected override itemIcon({
    icon,
    action,
    additionalStyling,
  }: {
    icon: string;
    action: () => Promise<void>;
    additionalStyling?: Styles;
  }) {
    return html`
      <d-icon
        solid
        @click=${action}
        ${css({
          padding: '8px',
          borderRadius: '4px',
          background: 'rgb(220, 220, 220)',
          color: '#333',
          cursor: 'pointer',
          ...(additionalStyling ?? {}),
        })}
      >
        ${icon}
      </d-icon>
    `;
  }
  protected override get configuration(): { icons: { edit: string; delete: string; save: string; cancel: string } } {
    return {
      icons: {
        edit: 'pen-to-square',
        delete: 'trash',
        save: 'floppy-disk',
        cancel: 'xmark',
      },
    };
  }
}
